import { Chip } from "@mui/material";

import { quoteCountText } from "utils";

import type { SxProps, Theme } from "@mui/material";

interface Props {
  quoteCount: number;
  size?: "small" | "medium";
  sx?: SxProps<Theme>;
}

export function QuoteCountChip(props: Props) {
  const { quoteCount, size, sx = {} } = props;

  return (
    <Chip
      label={<div className="quotes">{quoteCountText(quoteCount)}</div>}
      color="success"
      size={size}
      sx={sx}
    />
  );
}
